export const LANGUAGE_META = [
  { code: 'sv', name: 'Svenska', flag: '🇸🇪', google: 'sv' },
  { code: 'en', name: 'English', flag: '🇬🇧', google: 'en' },
  { code: 'no', name: 'Norsk', flag: '🇳🇴', google: 'no' },
  { code: 'fi', name: 'Suomi', flag: '🇫🇮', google: 'fi' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱', google: 'pl' },
  { code: 'es', name: 'Español', flag: '🇪🇸', google: 'es' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', google: 'de' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', google: 'fr' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹', google: 'it' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱', google: 'nl' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺', google: 'ru' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦', google: 'uk' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷', google: 'tr' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', google: 'ar' },
  { code: 'fa', name: 'فارسی', flag: '🇮🇷', google: 'fa' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳', google: 'hi' },
  { code: 'ur', name: 'اردو', flag: '🇵🇰', google: 'ur' },
  { code: 'bn', name: 'বাংলা', flag: '🇧🇩', google: 'bn' },
  { code: 'pt', name: 'Português', flag: '🇧🇷', google: 'pt' },
  { code: 'id', name: 'Bahasa Indonesia', flag: '🇮🇩', google: 'id' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳', google: 'vi' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭', google: 'th' },
  { code: 'ja', name: '日本語', flag: '🇯🇵', google: 'ja' },
  { code: 'ko', name: '한국어', flag: '🇰🇷', google: 'ko' },
  { code: 'zh', name: '中文', flag: '🇨🇳', google: 'zh' },
  { code: 'ta', name: 'தமிழ்', flag: '🇮🇳', google: 'ta' },
  { code: 'te', name: 'తెలుగు', flag: '🇮🇳', google: 'te' },
  { code: 'sw', name: 'Kiswahili', flag: '🇹🇿', google: 'sw' },
  { code: 'gu', name: 'ગુજરાતી', flag: '🇮🇳', google: 'gu' },
  { code: 'pa', name: 'ਪੰਜਾਬੀ', flag: '🇮🇳', google: 'pa' },
  { code: 'da', name: 'Dansk', flag: '🇩🇰', google: 'da' },
  { code: 'sq', name: 'Shqip', flag: '🇦🇱', google: 'sq' },
  { code: 'be', name: 'Беларуская', flag: '🇧🇾', google: 'be' },
  { code: 'bs', name: 'Bosanski', flag: '🇧🇦', google: 'bs' },
  { code: 'bg', name: 'Български', flag: '🇧🇬', google: 'bg' },
  { code: 'hr', name: 'Hrvatski', flag: '🇭🇷', google: 'hr' },
  { code: 'el', name: 'Ελληνικά', flag: '🇬🇷', google: 'el' },
  { code: 'cs', name: 'Čeština', flag: '🇨🇿', google: 'cs' },
  { code: 'et', name: 'Eesti', flag: '🇪🇪', google: 'et' },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺', google: 'hu' },
  { code: 'is', name: 'Íslenska', flag: '🇮🇸', google: 'is' },
  { code: 'lv', name: 'Latviešu', flag: '🇱🇻', google: 'lv' },
  { code: 'lt', name: 'Lietuvių', flag: '🇱🇹', google: 'lt' },
  { code: 'mk', name: 'Македонски', flag: '🇲🇰', google: 'mk' },
  { code: 'ro', name: 'Română', flag: '🇷🇴', google: 'ro' },
  { code: 'sr', name: 'Српски', flag: '🇷🇸', google: 'sr' },
  { code: 'sk', name: 'Slovenčina', flag: '🇸🇰', google: 'sk' },
  { code: 'sl', name: 'Slovenščina', flag: '🇸🇮', google: 'sl' },
  { code: 'mt', name: 'Malti', flag: '🇲🇹', google: 'mt' },
  { code: 'af', name: 'Afrikaans', flag: '🇿🇦', google: 'af' },
  { code: 'zu', name: 'isiZulu', flag: '🇿🇦', google: 'zu' },
  { code: 'km', name: 'ភាសាខ្មែរ', flag: '🇰🇭', google: 'km' },
  { code: 'ka', name: 'ქართული', flag: '🇬🇪', google: 'ka' },
  { code: 'ms', name: 'Bahasa Melayu', flag: '🇲🇾', google: 'ms' },
  { code: 'tl', name: 'Filipino', flag: '🇵🇭', google: 'tl' },
  { code: 'ht', name: 'Kreyòl Ayisyen', flag: '🇭🇹', google: 'ht' },
  { code: 'mi', name: 'Te Reo Māori', flag: '🇳🇿', google: 'mi' }
];

export const LANGUAGE_META_BY_CODE = LANGUAGE_META.reduce((acc, l) => {
  acc[l.code] = l;
  return acc;
}, {});

export const DEFAULT_LANGUAGE_CODES = LANGUAGE_META.map((l) => l.code);
